import api from "@/api";

export const whatsappService = {
  async getConversas() {
    const { data } = await api.get("/whatsapp/conversas");
    return data;
  },

  async getMensagens(conversaId) {
    const { data } = await api.get(
      `/whatsapp/conversas/${conversaId}/mensagens`
    );
    return data;
  },

  async marcarLida(conversaId) {
    const { data } = await api.post(
      `/whatsapp/conversas/${conversaId}/marcar-lida`,
      {}
    );
    return data;
  },

  async apagarConversa(conversaId) {
    const { data } = await api.post(
      `/whatsapp/conversas/${conversaId}/apagar`,
      {}
    );
    return data;
  },

  async enviarMensagem(payload) {
    const { data } = await api.post("/whatsapp/enviar", payload);
    return data;
  },

  async uploadImagem(formData) {
    const { data } = await api.post("/uploads/imagem", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
};
